export default __webpack_public_path__ + "static/media/carry-on-icon.8490940a.svg";